<!-- <ng-container *ngIf="listDivisas">
	<div *ngFor="let divisa of listDivisas">
		<div class="row form-group mx-auto mb-2">
			<div class="col-8">
				<h4 class="font-weight-bold">{{ divisa.nombre }}</h4>
			</div>
			<div class="col-4 text-center">
				<h4>
					<span class="fs-4 badge rounded-pill bg-primary text-light"> $ {{ divisa.valorClp | number : "1.2-2" : "es" }}</span>
				</h4>
			</div>
		</div>
	</div>
</ng-container> -->
<ng-container *ngIf="loadingDivisasValues$ | async">
	<div class="row">
			<span class="spinner spinner-primary spinner-xs"></span>
	</div>
</ng-container>
<div class="container-fluid align-items-center justify-content-between flex-wrap flex-sm-nowrap d-none d-lg-flex">
	<div class="d-flex align-items-center flex-wrap mr-2">
		<span class="text-muted font-weight-bold mr-4">Indicadores Económicos <b>{{stringDate}}</b></span>
		<div *ngFor="let divisa of listDivisas">
			<a href="#" class="btn btn-light-primary font-weight-bolder btn-sm ml-2">{{ divisa.nombre }}: $ {{ divisa.valorClp | number : "1.2-2" : "es" }}</a>
		</div>
	</div>
</div>